/* HOOPLUME — mobile sticky purchase bar. Video playback is managed by trikolumo-video.js. */
(function () {
  var root = document.querySelector('.th-home');
  if (!root || !('IntersectionObserver' in window)) return;

  /* barre collante : visible quand le bouton du bandeau a quitté l'écran, masquée dès que l'appel final arrive.
     L'état est recalculé à partir de la géométrie, donc aussi après un saut d'ancre ou un défilement brusque. */
  var bar = root.querySelector('[data-th-sticky]');
  var heroBtn = root.querySelector('[data-th-hero-cta]');
  var fin = root.querySelector('[data-th-final]');
  var barLink = bar && bar.querySelector('a');
  if (bar && heroBtn && fin) {
    var sync = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var on = heroBtn.getBoundingClientRect().bottom < 64 && fin.getBoundingClientRect().top > vh * 0.85;
      bar.classList.toggle('th-is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barLink) barLink.tabIndex = on ? 0 : -1;
    };
    var ioA = new IntersectionObserver(sync, { rootMargin: '-64px 0px 0px 0px' });
    ioA.observe(heroBtn);
    root.querySelectorAll('section').forEach(function (sec) { ioA.observe(sec); });
    new IntersectionObserver(sync, { rootMargin: '0px 0px -15% 0px' }).observe(fin);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });
    sync();
  }

})();
